export const yAxisOffset = 9;
export const axisLabelFontSize = 13;
export const tooltipFontSize = 12;
export const tooltipAnimationActive = false;
export const chartAnimationActive = false;
